import {Injectable} from '@angular/core';
@Injectable({providedIn: 'root'})
export class NotificacionService {
  async requestPermission(): Promise<string> {
    return 'Notification' in window ? await Notification.requestPermission() : 'unsupported';
  }
  show(title: string, options?: NotificationOptions, urlToOpen?: string): boolean {
    if (!('Notification' in window) || Notification.permission !== 'granted') return false;
    try {
      const notification = new Notification(title, options);
      notification.onclick = () => { window.focus(); notification.close(); };
      return true;
    } catch { return false; }
  }
}
